import { useLocation } from "react-router-dom";

export default function ProgressBar() {
  const location = useLocation();

  // Извлекаем номер страницы из URL
  const match = location.pathname.match(/\/quiz(\d+)/);
  const currentPage = match ? parseInt(match[1], 10) : 0;

  const totalPages = 36;
  const percentage = Math.min((currentPage / totalPages) * 100, 100);

  return (
    <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
      <div
        className="h-full bg-pinkCustom transition-all duration-300"
        style={{ width: `${percentage}%` }}
      />
    </div>
  );
}
